import './css/styles.scss';

function startbildKontaktInit() {}

startbildKontaktInit();
